module.exports = __webpack_public_path__ + "img/glovoLogo.9d187989.svg";